




















































































































































import { ConfirmButton, TwSelect, VariableAwareInput } from '@/app/components';
import { VariableType } from '@/app/constants';
import { Variable } from '@/app/interfaces';
import { S } from '@/app/utilities';
import { useParameter } from '@/modules/workflow-designer/composable';
import { InputParameter } from '@/modules/workflow-designer/types';
import { computed, defineComponent, PropType, ref, watch } from '@vue/composition-api';

import * as R from 'ramda';
import ParameterValidation from '../ParameterValidation.vue';

export default defineComponent({
    name: 'StringParameter',
    props: {
        value: {
            type: Object,
        },
        name: {
            type: String,
            required: true,
        },
        rules: {
            type: Object,
            default: () => {
                return {};
            },
        },
        parameter: {
            type: Object,
            required: true,
        },
        dataframes: {
            type: Object,
            default: () => {
                return {};
            },
        },
        columnsPerTask: {
            type: Object,
            default: () => {
                return {};
            },
        },
        strict: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        visible: {
            type: Boolean,
            default: true,
        },
        validationMessages: {
            type: Object,
            default: () => ({}),
        },
        availableVariables: {
            type: Object as PropType<Record<string, Variable>>,
            default: () => {
                return {};
            },
        },
        forceUpdate: {
            type: Date,
        },
    },
    components: { ParameterValidation, TwSelect, ConfirmButton, VariableAwareInput },
    setup(props, { emit }) {
        // Computed variables needed so that the composable
        // can react to their changes which is otherwise not possible at the moment
        const value = computed((): any => props.value);
        const visible = computed((): boolean => props.visible);
        const validationValue = ref<any>();

        const {
            currentValue,
            fixedList,
            isArray,
            addAnother,
            deleteEntry,
            change,
            changeDate,
            findInitialValue,
        } = useParameter(
            // the parameter definition
            props.parameter as InputParameter,

            // the current value of the parameter
            value as any,

            // if the parameter is visible or not
            visible,

            // send explicitly a new value
            (newValue: any) => {
                emit('change', { value: newValue });
            },

            // find initial value function
            (incomingValue: any) => {
                if (!S.has('value', incomingValue) || R.isNil(incomingValue?.value)) {
                    // Case no existing value defined
                    if (!R.isNil(props.parameter.validation) && S.has('default', props.parameter.validation)) {
                        // Case default value defined in validation information
                        if (props.parameter.multiple) {
                            if (!props.parameter.validation.default) {
                                return [];
                            }

                            if (R.is(Array, props.parameter.validation.default)) {
                                return props.parameter.validation.default;
                            }
                            return props.parameter.validation.default ? [props.parameter.validation.default] : [];
                        }
                        return props.parameter.validation.default ? props.parameter.validation.default : null;
                    }
                    // Case no default value defined in validation information then take default empty value
                    return props.parameter.multiple ? [] : null;
                }
                if (S.has('value', incomingValue) && incomingValue?.value && props.parameter.multiple) {
                    // Case where their is an existing value and the parameter is taking multiple values
                    return R.is(Array, incomingValue.value) ? incomingValue.value : [incomingValue.value];
                }
                if (!R.isNil(incomingValue.value) && !props.parameter.multiple) {
                    // Case where their is an existing value and the parameter is taking a single value
                    return !R.isNil(incomingValue.value) && !R.isEmpty(incomingValue.value)
                        ? incomingValue.value
                        : null;
                }
                return props.parameter.multiple ? [] : null;
            },

            // on value change
            () => {
                if (!R.isNil(currentValue)) {
                    if (!R.isNil(currentValue.value)) {
                        currentValue.value = findInitialValue(currentValue);
                    }
                    emit('change', { value: currentValue.value });
                }
            },
        );

        const validate = (newValue: string | number, index?: number) => {
            if (!R.isNil(index) && !R.is(Array, validationValue.value)) validationValue.value = [validationValue.value];
            if (!R.isNil(index)) validationValue.value[index] = newValue;
            else validationValue.value = newValue;
        };

        watch(
            () => validationValue.value,
            () => change(false),
        );

        watch(
            () => props.forceUpdate,
            () => (changeDate.value = new Date()),
        );

        // Set the initial value on load
        change();

        return {
            currentValue,
            isArray,
            addAnother,
            deleteEntry,
            fixedList,
            change,
            changeDate,
            VariableType,
            validate,
            validationValue,
        };
    },
});
